import type { EduCoursePaymentEntity } from '@common/types/payment-form.type';

import { createActionGroup, props } from '@ngrx/store';

const EduCoursePaymentsActions = createActionGroup({
    source: 'EduCoursePayments/Collection/API',
    events: {
        'Load Collection Request': props<{ courseId: number }>(),
        'Load Collection Success': props<{ courseId: number; eduCoursePayments: EduCoursePaymentEntity[] }>(),
        'Load Collection Failure': props<{ courseId: number; error: string }>(),
    },
});

export default EduCoursePaymentsActions;
